import { createSlice } from '@reduxjs/toolkit';

type DeployModalConfirmReducer = {
    previousDeploymentSummary: DeploymentSummary;
    newDeploymentSummary: DeploymentSummary;
    isCheckingNew: boolean;
};

const initialState: DeployModalConfirmReducer = {
    previousDeploymentSummary: {} as DeploymentSummary,
    newDeploymentSummary: {} as DeploymentSummary,
    isCheckingNew: false
};

const reportsSlice = createSlice({
    name: 'deployment-modal-confirm',
    initialState,
    reducers: {
        fetchingState(state) {
            state.isCheckingNew = true;
        },
        updateState(state, action) {
            const { previousDeploymentSummary, newDeploymentSummary } = action.payload;
            state.previousDeploymentSummary = previousDeploymentSummary;
            state.newDeploymentSummary = newDeploymentSummary;
            state.isCheckingNew = false;
        }
    }
});

export const { fetchingState, updateState } = reportsSlice.actions;
export type { DeployModalConfirmReducer };
export default reportsSlice.reducer;
